import * as React from 'react';
import {useDispatch} from 'react-redux';
import {setData} from '../data/paymentClientSlice';
import {createTransaction} from '../libs/GsmpiApi';
import {useNavigate} from 'react-router-dom';
import {setCookieDetails} from '../data/cookieDetailsSlice';
import {setUserDetails} from '../data/userDetailsSlice';
import {setBrowserDetails} from '../data/browserDetailsSlice';
import {useEffect} from 'react';
import {postMessageToParent} from '../utils/postMessage';
import {PAYMENT_TABS, POST_MESSAGE_TYPE} from '../common/constants';
import {createTestTransaction} from "../libs/GsmpiApiForStageTest";
import {setPaymentTabs} from "../data/paymentTabsSlice";
import Fingerprint2 from 'fingerprintjs2sync';

export default function Transactions() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSetCookieDetails = (cookieValue, hasCookies) => {
    const cookieDetails = {
      cookieValue: cookieValue,
      hasCookies: hasCookies
    };

    dispatch(setCookieDetails(cookieDetails));
  };

  const handleSetUserDetails = (userDetails, isSSOIntegrated) => {
    const userDetailsResponse = {
      userDetails: userDetails,
      isSSOIntegrated: isSSOIntegrated
    };

    dispatch(setUserDetails(userDetailsResponse));
  };

  const isValidPaymentTabs = (paymentTabsFromRequest) => {
    if (!paymentTabsFromRequest) {
      return true;
    }

    if (!Array.isArray(paymentTabsFromRequest)) {
      return false;
    }

    if (paymentTabsFromRequest) {
      for (const paymentTab of paymentTabsFromRequest) {
        if (!PAYMENT_TABS.includes(paymentTab)) {
          return false;
        }
      }
    }

    return true;
  };

  useEffect(() => {
    window.addEventListener(
      'message',
      event => {
        if (event.data && event.data.type && event.origin === event.data.sourceOrigin) {
          if (event.data.type === POST_MESSAGE_TYPE.CREATE_TRANSACTION) {
            const paymentRequest = event.data.content;
            paymentRequest.sourceOrigin = event.origin;

            const sourceOrigin = event.origin;
            const domains = event.data.domains;

            if (!isValidPaymentTabs(paymentRequest.paymentTabs)) {
              console.error('Invalid payment tabs values detected');
              navigate('/gsmpi-web/error');
            } else {
              createTransaction(paymentRequest).then(result => {
                if (result.data.cookieValue) {
                  handleSetCookieDetails(result.data.cookieValue, true);
                } else {
                  handleSetCookieDetails(undefined, false);
                }

                if (result.data.userDetails && result.data.userDetails.deviceList.length > 0) {
                  handleSetUserDetails(result.data.userDetails, true);
                } else {
                  handleSetUserDetails(undefined, false);
                }

                const browserId = (new Fingerprint2).getSync().fprint;
                dispatch(setBrowserDetails(browserId));

                dispatch(setData({
                  clientId: result.data.clientId,
                  transactionId: result.data.transactionId,
                  serviceId: paymentRequest.serviceId,
                  merchantName: paymentRequest.merchant.name,
                  sourceOrigin: sourceOrigin,
                  domains: domains
                }));

                const paymentTabs = paymentRequest.paymentTabs;
                if (paymentTabs) {
                  dispatch(setPaymentTabs(paymentTabs));
                }
              }).then(() => {
                navigate('/gsmpi-web/binding');
              }).catch(() => {
                navigate('/gsmpi-web/error');
              });
            }
          } else if (event.data.type === POST_MESSAGE_TYPE.CREATE_TEST_TRANSACTION) {
            const paymentRequest = event.data.content;
            paymentRequest.sourceOrigin = event.origin;
            const sourceOrigin = event.origin;
            const domains = event.data.domains;

            createTestTransaction(paymentRequest).then(result => {
              const browserId = (new Fingerprint2).getSync().fprint;
              dispatch(setBrowserDetails(browserId));

              dispatch(setData({
                clientId: result.data.clientId,
                transactionId: result.data.transactionId,
                serviceId: paymentRequest.serviceId,
                merchantName: paymentRequest.merchant.name,
                sourceOrigin: sourceOrigin,
                domains: domains
              }));
            }).then(() => {
              navigate('/gsmpi-web/test-transactions/bridge');
            }).catch(() => {
              navigate('/gsmpi-web/error');
            });
          }
        }
      },
      false
    );

    postMessageToParent({
      type: POST_MESSAGE_TYPE.READY_TO_CREATE_TRANSACTION,
      content: {},
      sourceOrigin: '*'
    });
  }, []);

  return (
    <>
      <div>
        Loading...
      </div>
    </>
  );
}
